import { render, staticRenderFns } from "./ClauseList.vue?vue&type=template&id=5d8db79b&scoped=true&"
import script from "./ClauseList.vue?vue&type=script&lang=js&"
export * from "./ClauseList.vue?vue&type=script&lang=js&"
import style0 from "./ClauseList.vue?vue&type=style&index=0&id=5d8db79b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8db79b",
  null
  
)

export default component.exports